import { render } from "./ViewCommitmentModal.vue?vue&type=template&id=1d89d48a&scoped=true"
import script from "./ViewCommitmentModal.vue?vue&type=script&lang=js"
export * from "./ViewCommitmentModal.vue?vue&type=script&lang=js"

import "./ViewCommitmentModal.vue?vue&type=style&index=0&id=1d89d48a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d89d48a"]])

export default __exports__